class MetricManager {
  constructor(data) {
    this.data = data
    this.totalAmountSpent = data.total_amount_spent ?? 0
    this.activeCustomerCount = data.active_customers_count ?? 0
    this.unique_users = data.unique_users ?? 0
    this.repeat_users = data.repeat_users ?? 0
    this.totalCompanyEmployeesCount = data.total_company_employees_count ?? 0
    this.activeEmployeesAppointmentsCount = data.active_employees_appointments_count ?? 0
    this.inactiveEmployeesAppointmentsCount = data.inactive_employees_appointments_count ?? 0
    this.activeDependentsAppointmentsCount = data.active_dependents_appointments_count ?? 0
    this.inactiveDependentsAppointmentsCount = data.inactive_dependents_appointments_count ?? 0
    this.activeEmployeesUpcomingAppointmentsCount = data.active_employees_upcoming_appointments_count ?? 0
    this.activeDependentsUpcomingAppointmentsCount = data.active_dependents_upcoming_appointments_count ?? 0
    this.activeUniqueEmployeesAppointmentsCount = data.active_unique_employees_appointments_count ?? 0
    this.inactiveUniqueEmployeesAppointmentsCount = data.inactive_unique_employees_appointments_count ?? 0
    this.activeUniqueDependentsAppointmentsCount = data.active_unique_dependents_appointments_count ?? 0
    this.inactiveUniqueDependentsAppointmentsCount = data.inactive_unique_dependents_appointments_count ?? 0
    this.totalHealthChecksCompleted = this.getTotalHealthChecksCompleted()
    this.healthCheckAvailedPercentage = this.getHealthCheckAvailedPercentage()
    this.totalSplitCount = this.totalSplitCount()
    this.totalBenefitSplitCount = this.totalBenefitSplitCount()
    this.donutGraphData = this.donutGraphData()
    this.donutBenefitGraphData = this.donutBenefitGraphData()
    this.partners = this.partners()
    this.successMetric = data.success_metric
    this.hasCustomerFormSubmissions = data.has_customer_form_submissions || false

    this.activeSponsoredEmployeesCount = data.active_customers_count ?? 0
    this.activeEmployeeUtilizationPercentage = this.floorPercentage(this.unique_users, this.activeSponsoredEmployeesCount)
    this.repeatSponsoredUserCount = data.repeat_users ?? 0
    this.repeatSponsoredUserCountPercentage = this.floorPercentage(this.repeat_users, this.activeSponsoredEmployeesCount)

    this.barLabelsWallet = this.getMonthOrder(data.month_on_month_transaction);
    this.bardataWallet = this.getBarData(data.month_on_month_transaction)
    this.monthOnMonthMaxValue = this.getMonthOnMonthMaxValue(data.month_on_month_transaction)
    this.highestValueNotation = this.getHighestValueNotation(this.bardataWallet)
    this.barBgColorsWallet = this.getBarBgColors(this.bardataWallet)
  }

    // Function to get the bar data in the correct order
  getBarData(monthData) {
      const dynamicOrder = this.getMonthOrder(monthData);

      // Initialize an object with all months in the dynamic order set to 0
      let monthOnMonthTransaction = dynamicOrder.reduce((acc, month) => {
      acc[month] = 0;
      return acc;
    }, {});

    // Populate the object with the actual data
    if (monthData && typeof monthData === 'object') {
      for (let [month, value] of Object.entries(monthData)) {
        if (dynamicOrder.includes(month)) {
          monthOnMonthTransaction[month] = value;
        }
      }
    }
    // Return the values in the order of dynamicOrder
    return dynamicOrder.map(month => monthOnMonthTransaction[month]);
  }

  getMonthOrder(monthData) {
    if (monthData === null || monthData === undefined) return [];

    const dataMonths = Object.keys(monthData);
    return dataMonths;
  }

  getBarBgColors(bardata){
    // Generate bar background colors
    return bardata.map(() => '#5A8BED');
  }

  getHighestValueNotation(arr){
    const maxValue = Math.max(...arr.map(Number))
    return this.getNumberNotation(maxValue)
  }

  getNumberNotation(value){
    if (value >= 10000000) {
      return 'Cr'; // Crores
    } else if (value >= 100000) {
      return 'L'; // Lakhs
    } else if (value >= 1000) {
      return 'K'; // Thousands
    }
    return '';
  }

  getUtilizatedPercentageAmount(num, total) {
    if (num === null || num === undefined) return '0';
    
    return   Math.round(total * (num/100))  
  }

  getTotalHealthChecksCompleted() {
    return (this.activeEmployeesAppointmentsCount + this.activeDependentsAppointmentsCount + this.inactiveEmployeesAppointmentsCount + this.inactiveDependentsAppointmentsCount)
  }

  getHealthCheckAvailedPercentage() {
    return this.activeCustomerCount ? Math.round((this.activeEmployeesAppointmentsCount / this.activeCustomerCount) * 100) : 0
  }

  floorPercentage(numerator, denominator, precision = 0) {
    const p = Math.pow(10, precision);
    return Math.round((numerator / denominator) * 100 * p) / p;
  }

  totalSplitCount() {
    let totalSplit = 0
    let splitData = this.data?.split || {}
    Object.keys(splitData).forEach((hashKey) => {
      totalSplit += splitData[hashKey]
    })

    return totalSplit
  }

  totalBenefitSplitCount() {
    let totalSplit = 0
    let splitData = this.data?.split_by_benefit_name || {}
    Object.keys(splitData).forEach((hashKey) => {
      totalSplit += splitData[hashKey]
    })

    return totalSplit
  }

  donutBenefitGraphData() {
    let result = []
    const { consultation24x7, inclinic_consultation, specialist_consultation } = this.data?.split_by_benefit_name || {}

    if(consultation24x7 > 0){
      result.push({
        text: 'Online GP Consultation',
        number: consultation24x7 || 0,
        percentage: consultation24x7 ? this.floorPercentage(consultation24x7, this.totalBenefitSplitCount) : 0,
        color: consultation24x7 ? '#5A8BED' : '#E5E8F0',
      })
    }
    if(inclinic_consultation > 0){
      result.push({
        text: 'Inclinic Consultation',
        number: inclinic_consultation || 0,
        percentage: inclinic_consultation ? this.floorPercentage(inclinic_consultation, this.totalBenefitSplitCount) : 0,
        color: inclinic_consultation ? '#3FCB7F' : '#E5E8F0',
      })
    }
    if(specialist_consultation > 0){
      result.push({
        text: 'Online Specialist Consultation',
        number: specialist_consultation || 0,
        percentage: specialist_consultation ? this.floorPercentage(specialist_consultation, this.totalBenefitSplitCount) : 0,
        color: specialist_consultation ? '#FFB500' : '#E5E8F0',
      })
    }

    return result
  }

  donutGraphData() {
    let result = []
    let benefitName = this.data.benefit_name?.toLowerCase()

    if(benefitName === 'vision') {
      const { vision, vision_wearable } = this.data?.split || {}

      if(vision > 0){
        result.push({
          text: 'Vision',
          number: vision || 0,
          percentage: vision ? this.floorPercentage(vision, this.totalSplitCount) : 0,
          color: vision ? '#5A8BED' : '#E5E8F0',
        })
      }
      if(vision_wearable > 0){
        result.push({
          text: 'Vision Wearable',
          number: vision_wearable || 0,
          percentage: vision_wearable ? this.floorPercentage(vision_wearable, this.totalSplitCount) : 0,
          color: vision_wearable ? '#3FCB7F' : '#E5E8F0',
        })
      }
    }else if(benefitName === 'consultation'){
      const { video, audio, center, instant_call, text, others } = this.data.split

      if(video > 0){
        result.push({
          text: 'Video',
          number: video || 0,
          percentage: video ? this.floorPercentage(video, this.totalSplitCount) : 0,
          color: video ? '#5A8BED' : '#E5E8F0',
        })
      }
      if(audio > 0){
        result.push({
          text: 'Audio',
          number: audio || 0,
          percentage: audio ? this.floorPercentage(audio, this.totalSplitCount) : 0,
          color: audio ? '#3FCB7F' : '#E5E8F0',
        })
      }
      if(center > 0){
        result.push({
          text: 'Center',
          number: center || 0,
          percentage: center ? this.floorPercentage(center, this.totalSplitCount) : 0,
          color: center ? '#FFB500' : '#E5E8F0',
        })
      }
      if(instant_call > 0){
        result.push({
          text: 'Instant Call',
          number: instant_call || 0,
          percentage: instant_call ? this.floorPercentage(instant_call, this.totalSplitCount) : 0,
          color: instant_call ? '#FF6B6B' : '#E5E8F0',
      })
      }
      if(text > 0){
        result.push({
          text: 'Text',
          number: text || 0,
          percentage: text ? this.floorPercentage(text, this.totalSplitCount) : 0,
          color: text ? '#A78BFA' : '#E5E8F0',
        })
      }
      if(others > 0){
        result.push({
          text: 'Others',
          number: others || 0,
          percentage: others ? this.floorPercentage(others, this.totalSplitCount) : 0,
          color: others ? '#2EC4C7' : '#E5E8F0',
        })
      }
    }else {
      const { center, home, camp, others, split } = this.data?.split || {}

      if(center > 0){
        result.push({
          text: 'Walk-In',
          number: center || 0,
          percentage: center ? this.floorPercentage(center, this.totalSplitCount) : 0,
          color: center ? '#5A8BED' : '#E5E8F0',
        })
      }
      if(home > 0){
        result.push({
          text: 'Home Collection',
          number: home || 0,
          percentage: home ? this.floorPercentage(home, this.totalSplitCount) : 0,
          color: home ? '#3FCB7F' : '#E5E8F0',
        })
      }
      if(camp > 0){
        result.push({
          text: 'OnSite',
          number: camp || 0,
          percentage: camp ? this.floorPercentage(camp, this.totalSplitCount) : 0,
          color: camp ? '#FFB500' : '#E5E8F0',
        })
      }
      if(split > 0){
        result.push({
          text: 'Split-Package',
          number: split || 0,
          percentage: split ? this.floorPercentage(split, this.totalSplitCount) : 0,
          color: split ? '#7B61FF' : '#E5E8F0',
        })
      }
      if(others > 0){
        result.push({
          text: 'Others',
          number: others || 0,
          percentage: others ? this.floorPercentage(others, this.totalSplitCount) : 0,
          color: others ? '#FF6B6B' : '#E5E8F0',
        })
      }
    }


    return result
  }


  partners() {
    return this.data.providers.map((item, key) => ({
      partner_name: item[0],
      employee_count: item[1],
    }))
  }

  getMonthOnMonthMaxValue(monthOnMonthTransaction) {
    if (monthOnMonthTransaction === null || monthOnMonthTransaction === undefined) return 0;
    let maxValue = 0;
    for (let [month, value] of Object.entries(monthOnMonthTransaction)) {
      if (value > maxValue) maxValue = value;
    }
    return maxValue;
  }
}

export default MetricManager
